import React from "react";
import {
  ErrorDiv,
  InputWrapper,
  InputHeader,
  StyledInput,
  SubmitButton,
  SubTitle,
} from "./newsletterStyles";

const NewsletterAddtionalInfo = ({
  handleInputChange,
  handleSubmit,
  submitError,
  secondary,
  finishedForm,
  errors,
}) => {
  return (
    <>
      <SubTitle secondary={secondary}>
        {finishedForm
          ? "Thanks, you have joined our mailing list!"
          : "Thanks, you have joined our mailing list! If you have time, it would be helpful for us to know more about you."}
      </SubTitle>
      {finishedForm ? null : (
        <form method="post" onSubmit={(event) => this.handleSubmit(event)}>
          <InputWrapper>
            <InputHeader secondary={secondary}>First name</InputHeader>
            <StyledInput
              onChange={(e) => handleInputChange(e.target.value, "firstName")}
              onClick={(e) => e.stopPropagation()}
              name="firstName"
              secondary={secondary}
            />
          </InputWrapper>
          <InputWrapper>
            <InputHeader secondary={secondary}>Last name</InputHeader>
            <StyledInput
              onChange={(e) => handleInputChange(e.target.value, "lastName")}
              onClick={(e) => e.stopPropagation()}
              name="lastName"
              secondary={secondary}
            />
          </InputWrapper>
          <InputWrapper>
            <InputHeader secondary={secondary}>Company</InputHeader>
            <StyledInput
              onChange={(e) => handleInputChange(e.target.value, "company")}
              onClick={(e) => e.stopPropagation()}
              name="company"
              secondary={secondary}
            />
          </InputWrapper>
          {submitError ? (
            <ErrorDiv secondary={secondary}>{submitError}</ErrorDiv>
          ) : null}
          <SubmitButton
            onClick={(e) => {
              e.stopPropagation();
              handleSubmit(e);
            }}
          >
            Submit
          </SubmitButton>
        </form>
      )}
    </>
  );
};

export default NewsletterAddtionalInfo;
